import { Card, CardBody, Col } from 'reactstrap'
import { SteplineCharts } from '../../../../Utils/Constants'
import ReactApexChart from 'react-apexcharts'
import { stepLineChartData } from '../../../../Data/Charts/ApexChart/ApexChartData'
import CommonCardHeader from '../../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader'

const SteplineChart = () => {
  return (
    <Col sm="12" xl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={SteplineCharts} />
        <CardBody>
          <div id="stepline">
            <ReactApexChart options={stepLineChartData} series={stepLineChartData.series} type="line" height={350} />
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default SteplineChart